export const FEATURED_PUBLIC_LABEL = "Destacado";

export const FEATURED_PUBLIC_TOOLTIP =
  "Esta ubicación puede ser promocionada. AutoMapa mantiene señales de confianza, disponibilidad y revisión visibles para ayudarte a comparar.";

export const PLACEMENT_STATUS_LABELS = {
  draft: "Borrador",
  scheduled: "Programado",
  active: "Activo",
  paused: "Pausado",
  expired: "Expirado",
  cancelled: "Cancelado",
  rejected: "Rechazado",
};

export const PLACEMENT_TYPES = [
  "featured_listing",
  "featured_dealer",
  "homepage_featured_listing",
  "homepage_featured_dealer",
  "search_top_slot",
  "search_inline_slot",
  "seo_page_featured_listing",
  "dealer_directory_featured",
];

export const SLOT_KEYS = [
  "homepage_hero_featured",
  "homepage_featured_grid",
  "search_top_1",
  "search_top_2",
  "search_inline_1",
  "seo_page_top",
  "dealer_directory_top",
];

export const FEATURED_ANALYTICS_EVENTS = {
  IMPRESSION: "featured_placement_impression",
  CLICKED: "featured_placement_clicked",
  VEHICLE_DETAIL: "featured_placement_vehicle_detail_viewed",
  WHATSAPP: "featured_placement_whatsapp_clicked",
  LEAD: "featured_placement_lead_created",
  DEALER_PROFILE: "featured_placement_dealer_profile_clicked",
};

export function trackFeaturedPlacementEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[featured-placement-event]", eventType, metadata);
  }
}

export function extractFeaturedListings(feed, slotKey) {
  const slot = feed?.slots?.[slotKey] || [];
  return slot.map((entry) => ({
    ...(entry.listingCard || entry.listing || {}),
    placementId: entry.placementId,
    slotKey: entry.slotKey,
    featuredLabel: entry.featuredLabel || FEATURED_PUBLIC_LABEL,
    featuredTooltip: entry.featuredTooltip || FEATURED_PUBLIC_TOOLTIP,
    isFeatured: true,
  }));
}

export function extractFeaturedDealers(feed, slotKey = "dealer_directory_top") {
  const slot = feed?.slots?.[slotKey] || [];
  return slot.map((entry) => ({
    ...entry.dealer,
    placementId: entry.placementId,
    featuredLabel: entry.featuredLabel || FEATURED_PUBLIC_LABEL,
    isFeatured: true,
  }));
}

export function dedupeListingsById(primary = [], secondary = []) {
  const ids = new Set(primary.map((item) => item.vehicleListingId || item.id));
  return secondary.filter((item) => !ids.has(item.vehicleListingId || item.id));
}
